export default __webpack_public_path__ + "static/media/NotoSans-SemiBold.1924c7aa.woff";